import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { AlertTriangle, X } from "lucide-react";
import { Button } from "@/components/ui";
export const Enable2FAModal = ({ onClose, onConfirm, isLoading })=>{
    const [isEnabling, setIsEnabling] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(null);
    const handleConfirm = async ()=>{
        setIsEnabling(true);
        setErrorMessage(null);
        try {
            await onConfirm();
            onClose();
        } catch (error) {
            const fallbackMessage = "Failed to enable 2FA requirement";
            setErrorMessage(error instanceof Error ? error.message : fallbackMessage);
        } finally{
            setIsEnabling(false);
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50",
        children: /*#__PURE__*/ _jsx("div", {
            className: "relative top-1/2 transform -translate-y-1/2 mx-auto p-5 border w-full max-w-md shadow-lg rounded-md bg-white",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-between mb-4",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ _jsx(AlertTriangle, {
                                            className: "h-6 w-6 text-amber-500"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "ml-2 text-lg font-medium text-gray-900",
                                        children: "Enable 2FA Requirement"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("button", {
                                onClick: onClose,
                                className: "text-gray-400 hover:text-gray-600",
                                disabled: isLoading || isEnabling,
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "sr-only",
                                        children: "Close"
                                    }),
                                    /*#__PURE__*/ _jsx(X, {
                                        className: "h-6 w-6"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-6 space-y-3",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm text-gray-600",
                                children: "Are you sure you want to require two-factor authentication for all users in your organization?"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "bg-amber-50 border border-amber-200 rounded-lg p-3",
                                children: /*#__PURE__*/ _jsxs("p", {
                                    className: "text-sm text-amber-700",
                                    children: [
                                        /*#__PURE__*/ _jsx("strong", {
                                            children: "Warning:"
                                        }),
                                        " This action cannot be undone. Once enabled, the 2FA requirement cannot be disabled."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-sm text-gray-600",
                                children: "All users without 2FA will be required to set it up on their next login."
                            })
                        ]
                    }),
                    errorMessage && /*#__PURE__*/ _jsx("p", {
                        className: "mb-4 text-sm text-red-600",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-end space-x-3",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                variant: "simple",
                                buttonStyle: "flat",
                                onClick: onClose,
                                disabled: isLoading || isEnabling,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed",
                                onClick: handleConfirm,
                                disabled: isLoading || isEnabling,
                                children: isLoading || isEnabling ? "Enabling..." : "Enable 2FA Requirement"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
